// initial state
const state = {
  user: {
    sessionId: "",
    userId: "",
    mobile: ""
  }
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  setUser(state, user) {
    //设置参数
    state.user = user;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/module/user.js